import { FilterBar, FormGroup, Label, Select } from '@celltrak/ui-components';

import useExceptionFilterBar from './hooks';

function ExceptionFilterBar() {
  const {
    aggregatorOptions,
    payerOptions,
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    filters,
  } = useExceptionFilterBar();

  return (
    <FilterBar
      onPrimaryClick={() => handleResetFilter()}
      buttonSize="sm"
      showPrimaryButton={showResetButton}
      showSecondaryButton={false}
      primaryButtonLabel="Reset"
    >
      <FormGroup>
        <Label for="aggregator-filter" size="sm">
          Aggregators
        </Label>
        <Select
          id="aggregator-filter"
          size="sm"
          options={aggregatorOptions}
          value={filters.aggregatorID}
          onChange={handleFilterChanges('aggregatorID')}
        />
      </FormGroup>
      {filters.aggregatorID && (
        <FormGroup>
          <Label for="payer-filter" size="sm">
            Payers
          </Label>
          <Select
            id="payer-filter"
            size="sm"
            options={payerOptions}
            value={filters.payerID}
            onChange={handleFilterChanges('payerID')}
          />
        </FormGroup>
      )}
    </FilterBar>
  );
}

export default ExceptionFilterBar;
